import { useQuery } from '@tanstack/react-query'

import { flowsService } from './flows-service'

export const useAllFlows = () => {
  const query = useQuery({
    queryKey: ['all-flows'],
    queryFn: flowsService.getAll
  })

  return query
}
export const useFlows = () => {
  const query = useQuery({
    queryKey: ['flows'],
    queryFn: flowsService.get
  })

  return query
}
